import React from 'react'

const EyeOpen = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 9.005C13.0609 9.005 14.0783 9.42643 14.8284 10.1766C15.5786 10.9267 16 11.9441 16 13.005C16 14.0659 15.5786 15.0833 14.8284 15.8334C14.0783 16.5836 13.0609 17.005 12 17.005C10.9391 17.005 9.92172 16.5836 9.17158 15.8334C8.42143 15.0833 8 14.0659 8 13.005C8 11.9441 8.42143 10.9267 9.17158 10.1766C9.92172 9.42643 10.9391 9.005 12 9.005ZM12 5.5C16.613 5.5 20.596 8.65 21.701 13.064C21.7494 13.2569 21.7192 13.4612 21.617 13.6319C21.5148 13.8025 21.3489 13.9256 21.156 13.974C20.9631 14.0224 20.7588 13.9922 20.5881 13.89C20.4175 13.7878 20.2944 13.6219 20.246 13.429C19.783 11.5925 18.7202 9.96306 17.226 8.79913C15.7319 7.6352 13.8919 7.00338 11.9979 7.00384C10.104 7.0043 8.26432 7.63701 6.77073 8.80167C5.27715 9.96632 4.21511 11.5962 3.753 13.433C3.72917 13.5286 3.68674 13.6186 3.62813 13.6978C3.56952 13.777 3.49589 13.8439 3.41144 13.8946C3.32698 13.9454 3.23336 13.979 3.13591 13.9935C3.03847 14.0081 2.93911 14.0033 2.8435 13.9795C2.7479 13.9557 2.65793 13.9132 2.57873 13.8546C2.49952 13.796 2.43264 13.7224 2.38189 13.6379C2.33114 13.5535 2.29753 13.4599 2.28296 13.3624C2.2684 13.265 2.27317 13.1656 2.297 13.07C2.83932 10.9073 4.08865 8.98777 5.84661 7.61627C7.60456 6.24476 9.77034 5.49991 12 5.5Z"
      fill="black"
    />
  </svg>
)

export default EyeOpen
